import { Typography } from '../../../../shared/view/components/Typography/Typography';

type SubTitleProps = {
  text: string;
};

export const ScreenSubTitle = ({ text }: SubTitleProps) => {
  return <Typography.P2 className="text-grey-300">{text}</Typography.P2>;
};
